<template>
  <t-modal
    :name="id"
    :variant="`lg`"
    :hideCloseButton="true"
    :disableBodyScroll="true"
    :escToClose="false"
    :clickToClose="false"
    ref="popup"
  >
    <section class="mt-8 px-5 text-2xl font-bold text-center">
      {{ title }}
    </section>

    <section class="p-5">
      <label class="flex items-center ml-2 my-3 cursor-pointer">
        <input
          v-model="drawingAction"
          type="radio"
          class="p-1 form-md-radio"
          name="drawingAction"
          :value="POLYGON_DRAWING_ACTION_TYPES.VEHICLES"
        />
        <span class="ml-2 text-lg font-semibold">Vehicles</span>
      </label>

      <label class="flex items-center ml-2 my-3 cursor-pointer">
        <input
          v-model="drawingAction"
          type="radio"
          class="p-1 form-md-radio"
          name="drawingAction"
          :value="POLYGON_DRAWING_ACTION_TYPES.PARKING_AREA"
        />
        <span class="ml-2 text-lg font-semibold">Parking Area</span>
      </label>
      <label class="flex items-center ml-2 my-3 cursor-pointer">
        <input
          v-model="drawingAction"
          type="radio"
          class="p-1 form-md-radio"
          name="drawingAction"
          :value="POLYGON_DRAWING_ACTION_TYPES.RESTRICTED_AREA"
        />
        <span class="ml-2 text-lg font-semibold">Restricted Area</span>
      </label>
      <label class="flex items-center ml-2 my-3 cursor-pointer">
        <input
          v-model="drawingAction"
          type="radio"
          class="p-1 form-md-radio"
          name="drawingAction"
          :value="POLYGON_DRAWING_ACTION_TYPES.SLOW_SPEED_AREA"
        />
        <span class="ml-2 text-lg font-semibold">Slow Speed Area</span>
      </label>
      <label class="flex items-center ml-2 my-3 cursor-pointer">
        <input
          v-model="drawingAction"
          type="radio"
          class="p-1 form-md-radio"
          name="drawingAction"
          :value="POLYGON_DRAWING_ACTION_TYPES.PRIORITY_ZONE"
        />
        <span class="ml-2 text-lg font-semibold">Priority Zone</span>
      </label>
    </section>

    <section class="flex items-center py-4 px-4 mt-6 space-x-5 bg-gray-100">
      <anchor-button
        :variant="cancelButtonVariant"
        :class="`w-1/2`"
        @click="executeAction('cancel')"
      >
        {{ cancelButtonText }}
      </anchor-button>

      <anchor-button
        :variant="confirmButtonVariant"
        :class="`w-1/2`"
        @click="executeAction('confrim')"
      >
        {{ confirmButtonText }}
      </anchor-button>
    </section>
  </t-modal>
</template>

<script>
import { POLYGON_DRAWING_ACTION_TYPES } from '@/store/modules/live-map/live-map.helpers'

export default {
  name: 'ConfirmFirst',
  components: {
    AnchorButton: () => import('@/components/form/AnchorButton.vue'),
  },

  props: {
    id: {
      type: [String, Number],
      requred: true,
    },
    title: {
      type: [String, Number],
      required: false,
      default: 'Are you sure?',
    },
    cancelButtonText: {
      type: [String, Number],
      required: false,
      default: 'Cancel',
    },
    cancelButtonVariant: {
      type: String,
      required: false,
      default: 'secondary',
      validaotor(val) {
        return [
          'primary',
          'secondary',
          'success',
          'success-alt',
          'warning',
          'warning-alt',
          'disabled',
        ].includes(val)
      },
    },
    confirmButtonText: {
      type: [String, Number],
      required: false,
      default: 'Continue',
    },
    confirmButtonVariant: {
      type: String,
      required: false,
      default: 'primary',
      validator(val) {
        return [
          'primary',
          'secondary',
          'success',
          'success-alt',
          'warning',
          'warning-alt',
          'disabled',
        ].includes(val)
      },
    },
  },

  data: () => ({
    POLYGON_DRAWING_ACTION_TYPES: POLYGON_DRAWING_ACTION_TYPES,
    drawingAction: POLYGON_DRAWING_ACTION_TYPES.VEHICLES,
  }),

  methods: {
    executeAction(type) {
      if (type === 'confrim') {
        this.$emit('confirm', this.drawingAction)
        this.$refs.popup.hide()
      }

      if (type === 'cancel') {
        this.$refs.popup.hide()
        this.$emit('cancel')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.popup-container {
  display: grid;
  grid-template-rows: auto 1fr auto;
}

.form-md-radio {
  /* Reset appearance */
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  /* Size and layout */
  width: 1.4rem;
  height: 1.4rem;
  border: 2px solid #000;
  border-radius: 9999px;
  background-color: #fff;
  cursor: pointer;
  position: relative;
  display: inline-block;
  vertical-align: middle;
  transition: all 0.2s ease;

  /* Accessibility improvements */
  outline: none;
}

.form-md-radio:checked {
  background-color: #000;
}

.form-md-radio:checked::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0.5rem;
  height: 0.5rem;
  background-color: #fff;
  border-radius: 9999px;
  transform: translate(-50%, -50%);
}

/* Focus ring for accessibility */
.form-md-radio:focus-visible {
  outline: 2px solid #2563eb;
  outline-offset: 2px;
}

/* Responsive - scale for smaller screens if needed */
@media (max-width: 640px) {
  .form-md-radio {
    width: 1.25rem;
    height: 1.25rem;
  }

  .form-md-radio:checked::before {
    width: 0.4rem;
    height: 0.4rem;
  }
}
</style>
